module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0031.png.d1fa7c50.jpg";